import React from "react";
import { Col, Row } from "react-bootstrap";
import ArrowDropDownCircleIcon from "@mui/icons-material/ArrowDropDownCircle";
import Accordion from "react-bootstrap/Accordion";
// import coin_top from "../Assets/images/coin-bg-icon.png";
// import platinum_waves from "../Assets/images/platinum-waves.png";
// import platinum_base from "../Assets/images/platinum-base.png";
import pic from "../Assets/images/features-2.png";
import Ist_left from "../Assets/images/img-agency-section.webp";
import Ist_right from "../Assets/images/designnew.svg";
import Ist_right1 from "../Assets/images/designnew1.svg";
import cut_iamge from "../Assets/images/agency-section-03.webp";
import branding_logo from "../Assets/images/branding_logo.svg";
import stragety from "../Assets/images/stragety.svg";
import user_experience from "../Assets/images/user_experience.svg";
import { Link } from "react-router-dom";
import join_img from "../Assets/images/join_img.webp";
import join_wave from "../Assets/images/join_wave.webp";

const WebDesign = () => {
  return (
    <>
      <div className="web_section ">
        <div className="banner_section">
          <div className="container-layout">
            <Row>
              <Col xl={12} lg={12} md={12}>
                <div className="left_col">
                  <div className="home-link">
                    <p>CREATIVE</p>
                    <p>/</p>
                    <p>RESPONSIVE</p>
                    <p>/</p>
                    <p>CLEAN CODE</p>
                  </div>
                  <h2>Web Designing</h2>
                  <p>
                    Create and retain your online presence with dazzling and
                    unique website designs to instigate, engross, and deliver
                    outcomes.
                  </p>
                  <div className="btns-banner">
                    <Link to="/contact" className="btn contact_btn">
                      Contact us
                    </Link>
                    {/* <Link
                      to={"tel:" + phone_number}
                      className="link-t Phone is-animating"
                    ></Link> */}
                  </div>
                </div>
              </Col>
            
            </Row>
          </div>
        </div>

        <div className="first_section">
          <div className="container-layout">
            <div className="heading_sec">
              <h2>Websites that tell your brand's story</h2>
              <p>
                We fuel the growth of purpose driven brands through strategy
                activation, design empowerment, and market adoption.
              </p>
            </div>
            <Row>
              <Col xl={6}>
                <div className="first_left">
                  <div className="Ist_left_image">
                    <img src={Ist_left} alt="Ist_left" />
                  </div>
                  <div className="cut_image">
                    <img src={cut_iamge} alt="cut_iamge" />
                  </div>
                  <div className="span_section">
                    <h3>24 +</h3>
                    <p>Startups created</p>
                  </div>
                </div>
              </Col>
              <Col xl={6}>
                <div className="first_right">
                  <h3>
                    We’re design-focused across every touchpoint or interaction
                  </h3>
                  <p>
                    Everything we do and dream up has a solid design impact.We
                    create human-centered enterprise software that has the
                    polished, snappy feel of the best consumer apps.
                  </p>
                  <div className="for_flex_div">
                    <div className="ux_design">
                      <img src={Ist_right} alt="Ist_right" />
                      <h5>UI/UX Design</h5>
                      <p>
                        We design digital products used by millions of people.
                      </p>
                    </div>
                    <div className="ux_design">
                      <img src={Ist_right1} alt="Ist_right" />
                      <h5>Development</h5>
                      <p>
                        We design digital products used by millions of people.
                      </p>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>

        <div className="third_section">
          <div className="container-layout">
            <div className="creative_designers">
              <div className="head_section_third">
                <div className="left_head_third">
                  <p>
                    BRINGING LOGIC TO DESIGN WITH A SPIRIT OF CURIOSITY AND
                    EXCITEMENT
                  </p>
                  <h3>A team of creative designers & strategists</h3>
                </div>
                <div className="btns-banner learn_btn">
                  <Link to="/about" className="btn contact_btn">
                    About Us
                  </Link>
                  {/* <Link
                    to={"tel:" + phone_number}
                    className="link-t Phone is-animating"
                  ></Link> */}
                </div>
              </div>

              <Row>
                <Col xl={4} lg={4} md={6}>
                  <div className="Branding">
                    <img src={branding_logo} alt="branding_logo" />
                    <div className="brand_logo">
                      <h6>Branding</h6>
                      <p>
                        See your authentic mission, and values come to life with
                        a unique brand image.
                      </p>
                    
                    </div>
                  </div>
                </Col>
                <Col xl={4} lg={4} md={6}>
                  <div className="Branding">
                    <img
                      src={stragety}
                      alt="branding_logo"
                      className="stragety_image"
                    />
                    <div className="brand_logo">
                      <h6>Strategy</h6>
                      <p>
                        See your authentic mission, and values come to life with
                        a unique brand image.
                      </p>
               
                    </div>
                  </div>
                </Col>
                <Col xl={4} lg={4} md={6}>
                  <div className="Branding">
                    <img
                      src={user_experience}
                      alt="branding_logo"
                      className="user_experience"
                    />
                    <div className="brand_logo">
                      <h6>User Experience</h6>
                      <p>
                        See your authentic mission, and values come to life with
                        a unique brand image.
                      </p>
                   
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </div>

        <div className="second_section">
          <div className="container-layout">
            <Row className="row_banner">
              <div className="heading_section">
                <p className="heading_best">
                  BEST WEB DESIGNING COMPANY IN ABOHAR{" "}
                </p>
                <h3>Web Designing</h3>
              </div>
              <Col xl={6} lg={6}>
                <div className="left_second">
                  <p className="when_txt">
                    When it comes to marketing, imaginative assets are secondary
                    to our concentration on content. But if we see reality, then
                    design and creativity can make a significant difference in
                    the content’s sustainability. Using high-quality images on
                    different social media platforms can help a website entice
                    more attention, and to increase conversions, a website
                    should have a well-organized layout on the landing page. As
                    a top priority, design matters a lot and this is how our
                    team of designers can help you.
                  </p>
                  <p className="when_txt">
                    We, at Gs Infotech Web Solutions, have stunning web designing
                    packages to offer. Being a highly-skilled and
                    well-experienced web design company, a lot of businesses
                    rely on us to meet their requirements, and expectations in
                    an affordable and unique manner. Regardless of the reason
                    why you want to hire us, we are always ready to serve you
                    with dedication, determination, and professionalism. Our
                    team of diligent designers can:
                  </p>

                  <p className="when_txt">
                    Our skilled web designers can design corporate websites,
                    custom websites, e-commerce websites, Progressive Web App,
                    Accelerated Mobile Pages, and much more. So, come to us and
                    be prepared to get your dream website designed with the
                    latest design ideas and technologies. We assure you to give
                    a design for your website that will look appealing in the
                    huge crowd. Explore our cheaper web designing packages to
                    stand out in the online business world.
                  </p>
                </div>
              </Col>
              <Col xl={6} lg={6}>
                <div className="second_right">
                  <div className="image_div">
                    <img src={pic} alt="pic" />
                  </div>
                  <ul>
                    <div className="div_list">
                      <div>
                        <li>
                          <ArrowDropDownCircleIcon className="arrow_icon" />
                          Create a new, engaging website
                        </li>

                        <li>
                          <ArrowDropDownCircleIcon className="arrow_icon" />
                          Redesign existing website
                        </li>
                        <li>
                          <ArrowDropDownCircleIcon className="arrow_icon" />
                          Maintain and transform websites
                        </li>
                      </div>
                      {/* <div className="gif_image">
                        <img src={gif_image} alt="gif_image" />
                    </div> */}
                      <div>
                        <li>
                          <ArrowDropDownCircleIcon className="arrow_icon" />
                          Make a website mobile-friendly
                        </li>
                        <li>
                          <ArrowDropDownCircleIcon className="arrow_icon" />
                          Add e-commerce to websites
                        </li>
                        <li>
                          <ArrowDropDownCircleIcon className="arrow_icon" />
                          Customized web development
                        </li>
                      </div>
                    </div>
                  </ul>
                </div>
              </Col>
            </Row>
          </div>
        </div>

        <div className="faq_Sec">
          <div className="container-layout">
            <h2 className="text-center">
              Frequently Asked <span>Questions</span>
            </h2>
            <p className="text-center">
              A small river named Duden flows by their place and supplies it
              with the necessary regelialia. It is a paradise
            </p>
            <div className="row faq_row">
              <Col xl={12}>
                <div className="faq_accordion">
                  <Accordion defaultActiveKey="">
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>
                        {" "}
                        How to Change my Photo from Admin Dashboard?{" "}
                      </Accordion.Header>
                      <Accordion.Body>
                        Far far away, behind the word mountains, far from the
                        countries Vokalia and Consonantia, there live the blind
                        texts. Separated they live in Bookmarksgrove right at
                        the coast.
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="1">
                      <Accordion.Header>
                        {" "}
                        How to Change my Password easily?
                      </Accordion.Header>
                      <Accordion.Body>
                        Far far away, behind the word mountains, far from the
                        countries Vokalia and Consonantia, there live the blind
                        texts. Separated they live in Bookmarksgrove right at
                        the coast
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="2">
                      <Accordion.Header>
                        {" "}
                        How to Change my Subscription Plan using PayPal?
                      </Accordion.Header>
                      <Accordion.Body>
                        Far far away, behind the word mountains, far from the
                        countries Vokalia and Consonantia, there live the blind
                        texts. Separated they live in Bookmarksgrove right at
                        the coast
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
              </Col>
            </div>
          </div>
        </div>

        <div className="forth_section">
          <div className="container-layout">
            <Row className="forth-row">
              <Col xl={6} lg={6} md={6}>
                <div className="web-readys">
                  <h2>Ready to get started with your new project today?</h2>
                  <p>
                    Identify your authentic brand & shop elements through an
                    in-depth exploration, receive unique strategies to clarify
                    your vision, strengthen differentiation, and prime your
                    company for growth.
                  </p>
                  <div className="web-form">
                    <input type="email" id="email" placeholder="your email address" required />
                    <input type="submit" id="btn" value="Sign up" />
                  </div>
                </div>
              </Col>

              <Col xl={6} lg={6} md={6}>
                <div className="right_image">
                  <div className="side_img">
                    <img src={join_img} alt="join_img" className="main_img" />
                  </div>

                  <div className="inner_image">
                    <span>150</span>

                    <h6>Projects in 2023</h6>
                  </div>

                  <div className="join_wave">
                    <img src={join_wave} alt="join_wave"/>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </>
  );
};

export default WebDesign;
